const FilledCircleCheckIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M9.417 3.37a6.649 6.649 0 0 0-5.335 3.74 6.651 6.651 0 0 0-.327 4.993c.158.486.58 1.323.87 1.728 1.065 1.486 2.569 2.429 4.392 2.753.409.073 1.285.1 1.713.053 3.049-.334 5.448-2.593 5.935-5.588a7.678 7.678 0 0 0 0-2.098 6.737 6.737 0 0 0-2.982-4.56A6.825 6.825 0 0 0 9.417 3.37m4.076 3.977c.306.16.426.523.274.834-.093.193-4.305 4.397-4.474 4.468a.707.707 0 0 1-.502.006c-.059-.025-.671-.578-1.359-1.23-1.361-1.288-1.387-1.319-1.358-1.623.042-.441.508-.701.886-.494.075.042.509.429.963.86.455.432.892.843.971.915l.144.129 1.923-1.919c1.057-1.055 1.952-1.935 1.989-1.955.096-.052.438-.046.543.009"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { FilledCircleCheckIcon };
